import React, { useState } from 'react';
import './Contact.css';
import { useComponentAnalytics } from '../hooks/useAnalytics';

const Contact = () => {
  const { trackInteraction } = useComponentAnalytics('Contact');
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Track form field interactions
    trackInteraction('form_field_focus', 'input', {
      field_name: name,
      field_type: e.target.type
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    // Track form submission
    trackInteraction('form_submit', 'form', {
      form_type: 'contact_form',
      has_name: !!formData.name,
      has_email: !!formData.email,
      has_message: !!formData.message,
      message_length: formData.message.length
    });
    
    // Here you would normally handle the form submission
    console.log('Form submitted:', formData);
    alert('Gracias por tu mensaje. Te contactaremos pronto!');
    
    // Reset form
    setFormData({ name: '', email: '', message: '' });
  };

  const handleContactInfoClick = (contactType) => {
    trackInteraction('contact_info_click', 'link', {
      contact_type: contactType
    });
  };

  return (
    <section id="contacto" className="contact">
      <div className="container">
        <div className="contact-header">
          <h2>Contáctanos</h2>
          <p>¿Quieres saber más sobre ExpertMind? Nos encantaría conversar contigo.</p>
        </div>
        
        <div className="contact-content">
          <div className="contact-info">
            <h3>Información de contacto</h3>
            <div className="contact-item">
              <div className="contact-icon">📧</div>
              <div className="contact-detail">
                <strong>Email:</strong> 
                <a 
                  href="mailto:info@expertmind.com.ar"
                  onClick={() => handleContactInfoClick('email')}
                >
                  info@expertmind.com.ar
                </a>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">💼</div>
              <div className="contact-detail">
                <strong>LinkedIn:</strong> 
                <a 
                  href="https://linkedin.com/company/107913973"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => handleContactInfoClick('linkedin')}
                >
                  linkedin.com/company/107913973
                </a>
              </div>
            </div>
            
            <div className="contact-cta-box">
              <h4>¿Prefieres una demo en vivo?</h4>
              <p>Agenda una reunión con nuestro equipo y descubre cómo ExpertMind puede transformar tu empresa.</p>
              <a href="mailto:info@expertmind.com.ar?subject=Solicitud de Demo" className="btn btn-secondary">
                <span>Agendar Demo</span>
                <span className="btn-icon">📅</span>
              </a>
            </div>
          </div>
          
          <form className="contact-form" onSubmit={handleFormSubmit} aria-label="Formulario de contacto">
            <div className="form-group">
              <label htmlFor="name">Nombre completo</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                value={formData.name}
                onChange={handleInputChange}
                onFocus={(e) => handleInputChange(e)}
                placeholder="Tu nombre"
                required 
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email corporativo</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                value={formData.email}
                onChange={handleInputChange}
                onFocus={(e) => handleInputChange(e)}
                placeholder="tu@empresa.com"
                required 
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Mensaje</label>
              <textarea 
                id="message" 
                name="message" 
                rows="5" 
                value={formData.message}
                onChange={handleInputChange}
                onFocus={(e) => handleInputChange(e)}
                placeholder="Cuéntanos sobre tu proyecto y cómo podemos ayudarte..."
                required
              ></textarea>
            </div>
            <button type="submit" className="submit-btn">
              <span>Enviar mensaje</span>
              <span className="btn-icon">→</span>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
